import { reportePosiciones } from './../../../../../../_entities/coordenadas/ReportePosiciones';
import { HistorialVelocidadesVehiculoService } from './../../../../services/historial-velocidades-vehiculo.service';
import { MapaService } from './../../../../../../views/monitoreo/services/mapa.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { AuthService } from './../../../../../../views/auth/auth.service';
import { finalize } from 'rxjs/operators';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'kt-historial-velocidades-vehiculo',
	templateUrl: './historial-velocidades-vehiculo.component.html',
	styleUrls: ['./historial-velocidades-vehiculo.component.scss']
})
export class HistorialVelocidadesVehiculoComponent implements OnInit {
	@ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent;

	public reporte: any = [];
	public dataGrafica = [];
	public datos = [[1, 1]];
	public type = "line"
	public energySources = [
		{ value: "velocidad", name: "Velocidad" }
	];
	public vehiculoInfo;
	public idCliente;
	public fechaInicial;
	public fechaFinal;
	public fechaInicio;
	public idVehiculo;
	public fechaFin;
	public showFilterRow: boolean;
	public loadingVisible: boolean = false;
	public showPDFButton: boolean = false;
	public HWUser;

	public showForm: boolean = true;

	colorScheme = {
		domain: ['#166BA2']
	};


	public legend: boolean = true;
	public showLabels: boolean = true;
	public animations: boolean = true;
	public xAxis: boolean = true;
	public yAxis: boolean = true;
	public showYAxisLabel: boolean = true;
	public showXAxisLabel: boolean = true;
	public timeline: boolean = true;
	public showGrafica = false;

	constructor(@Inject(MAT_DIALOG_DATA) public data: any,
		private authService: AuthService,
		private datepipe: DatePipe,
		private toastService: ToastrService,
		public dialogRef: MatDialogRef<HistorialVelocidadesVehiculoComponent>,
		private historialVelocidadesVehiculoService: HistorialVelocidadesVehiculoService,
		private mapaService: MapaService) { }

	ngOnInit() {
		this.HWUser = this.authService.getHWUser();
		if (this.data !== null) {
			this.idCliente = this.data.idCliente;
			this.idVehiculo = this.data.id;
			this.vehiculoInfo = this.data;
		} else {
			this.showForm = false;
			const lista = JSON.parse(sessionStorage.getItem('historico'));
			this.data = this.mapaService.datosGenerales
			//this.idVehiculo = this.mapaService.datosGenerales.id
			const len = lista.length - 1;
			this.fechaInicial = this.mapaService.historicoFechas[0];
			this.fechaFinal = this.mapaService.historicoFechas[1];
			this.reportePosicionDefault(this.fechaInicial, this.fechaFinal);
		}

	}

	/**Obtener Reporte Velocidad */
	etiquetaModificada(arg) {

		return {
            text: arg.valueText + ' km/h'
        };
	}

	reportePosicion(fechaInicio: Date, fechaFin: Date) {
		if (this.validationGroup.instance.validate().isValid) {
			this.loadingVisible = true;
			this.fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd HH:mm:ss");
			this.fechaFinal = this.datepipe.transform(fechaFin, "yyyy-MM-dd HH:mm:ss");

			if (this.idCliente != 39) {
				this.reporte = [];
				this.historialVelocidadesVehiculoService.graficarVelocidad(this.idVehiculo, this.fechaInicial, this.fechaFinal).pipe(
					finalize(
						() => this.loadingVisible = false
					)
				).subscribe((res: reportePosiciones[]) => {
					this.reporte = res;

					this.reporte.map(rep => {
						rep.fecha = this.datepipe.transform(rep.fecha, 'yyyy-MM-dd HH:mm')
					});

					this.showGrafica = true;
					this.showPDFButton = true;
				});
			} else {
				const pageNum = '-1';
				const pageCount = -1
				this.historialVelocidadesVehiculoService.obtenerAutosCamara(pageNum, pageCount, this.fechaInicial, this.fechaFinal, this.data.imeiFk).pipe(
					finalize(
						() => { this.loadingVisible = false }
					)
				).subscribe(
					(response) => {

						let locations = [];
						if (response.data != null) {
							response.data.forEach(dato => {
								let ignicion = 0;
								let estado = 0
								if (Number(dato.speed) > 5) {
									ignicion = 1;
									estado = 1;
								}

								let formAux = {
									anio: response.vehiculo.anio,
									placas: response.vehiculo.placas,
									economico: response.vehiculo.economico,
									numeroSerie: response.vehiculo.numeroSerie,
									color: response.vehiculo.color,
									descripcion: response.vehiculo.descripcion,
									imagen: response.vehiculo.imagen,
									modelo: response.vehiculo.modelo,
									estatus: response.vehiculo.estatus,
									imeiFk: response.vehiculo.imeiFk,
									lat: Number(dato.latitude),
									lng: Number(dato.longitude),
									estado: estado,
									ignicion: ignicion,
									velocidad: Math.round(dato.speed),
									direccion: response.vehiculo.direccion,
									odometro: response.vehiculo.odometro,
									marca: response.vehiculo.marca,
									fechaHoraUltimaPosicion: response.vehiculo.fechaHoraUltimaPosicion,
									estaEnMovimiento: response.vehiculo.estaEnMovimiento,
									fecha: dato.dtu,
									idPosicion: response.vehiculo.idPosicion,
									idCliente: response.vehiculo.idCliente
								}
								locations.push(formAux);
							});

							this.reporte = locations;

							this.reporte.map(rep => {
								rep.fecha = this.datepipe.transform(rep.fecha, 'yyyy-MM-dd HH:mm:ss')
							});
							this.showGrafica = true;
							this.showPDFButton = true;

						} else {

						}
					}
				)

			}
		} else {
			this.toastService.warning('Existen campos requerídos vacíos')
		}

	}

	reportePosicionDefault(fechaInicio: Date, fechaFin: Date) {
		this.loadingVisible = true;
		this.fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd HH:mm:ss");
		this.fechaFinal = this.datepipe.transform(fechaFin, "yyyy-MM-dd HH:mm:ss");

		const pageNum = '-1';
		const pageCount = -1
		this.historialVelocidadesVehiculoService.obtenerAutosCamara(pageNum, pageCount, this.fechaInicial, this.fechaFinal, this.data.imeiFk).pipe(
			finalize(
				() => { this.loadingVisible = false }
			)
		).subscribe(
			(response) => {

				let locations = [];
				if (response.data != null) {
					response.data.forEach(dato => {
						let ignicion = 0;
						let estado = 0
						if (Number(dato.speed) > 5) {
							ignicion = 1;
							estado = 1;
						}

						let formAux = {
							anio: response.vehiculo.anio,
							placas: response.vehiculo.placas,
							economico: response.vehiculo.economico,
							numeroSerie: response.vehiculo.numeroSerie,
							color: response.vehiculo.color,
							descripcion: response.vehiculo.descripcion,
							imagen: response.vehiculo.imagen,
							modelo: response.vehiculo.modelo,
							estatus: response.vehiculo.estatus,
							imeiFk: response.vehiculo.imeiFk,
							lat: Number(dato.latitude),
							lng: Number(dato.longitude),
							estado: estado,
							ignicion: ignicion,
							velocidad: Math.round(dato.speed),
							direccion: response.vehiculo.direccion,
							odometro: response.vehiculo.odometro,
							marca: response.vehiculo.marca,
							fechaHoraUltimaPosicion: response.vehiculo.fechaHoraUltimaPosicion,
							estaEnMovimiento: response.vehiculo.estaEnMovimiento,
							fecha: dato.dtu,
							idPosicion: response.vehiculo.idPosicion,
							idCliente: response.vehiculo.idCliente
						}
						locations.push(formAux);
					});

					this.reporte = locations;

					this.reporte.map(rep => {
						rep.fecha = this.datepipe.transform(rep.fecha, 'yyyy-MM-dd HH:mm:ss')
					});
					this.showGrafica = true;
					this.showPDFButton = true;

				} else {

				}
			}
		)


	}

	imprimirPdf() {
		this.loadingVisible = true;
		var grafica = document.getElementById('grafica')
		const PLACA = this.validarInfo(this.vehiculoInfo.placas);
		const ECONOMICO = this.validarInfo(this.vehiculoInfo.economico);
		const SERIE = this.validarInfo(this.vehiculoInfo.numeroSerie)
		const MARCA = this.validarInfo(this.vehiculoInfo.marca);
		const MODELO = this.validarInfo(this.vehiculoInfo.modelo);
		const ANIO = this.validarInfo(this.vehiculoInfo.anio);
		const COLOR = this.validarInfo(this.vehiculoInfo.color);
		const DESCRIPCION = this.validarInfo(this.vehiculoInfo.descripcion);
		let fechaHora = this.vehiculoInfo.fechaHoraUltimaPosicion;

		const FECHA_INICIAL = this.datepipe.transform(this.fechaInicial, 'dd/MM/yyyy h:MM a');
		const FECHA_FINAL = this.datepipe.transform(this.fechaFinal, 'dd/MM/yyyy h:MM a');

		fechaHora = this.datepipe.transform(fechaHora, 'yyyy-MM-dd h:mma');
		let direccion;

		this.mapaService.getDireccion([this.vehiculoInfo.lat, this.vehiculoInfo.lng]).then(
			(data: any) => {
				direccion = data.display_name || "Dirección Desconocida";
			},
			() => {
				direccion = "Dirección Desconocida";
			}
		);

		setTimeout(async () => {
			await html2canvas(grafica).then(
				(canvas) => {
					const graficaImagen = canvas.toDataURL('image/png');

					var pdf = new jsPDF('p', 'pt', 'a4');

					const logoGTM = './assets/media/logos/logo-gtm.png'
					const logoGTMX = 20;
					const logoGTMY = 15;
					const logoGTMWidth = 180;
					const logoGTMHeight = 80;
					pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

					const logoGTMWater = './assets/media/logos/marca-de-agua.png'
					const logoGTMWaterX = 15;
					const logoGTMWaterY = 130;
					const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
					const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
					const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
					pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');

					pdf.setFontSize(18);
					pdf.setFont('', 'bold')
					pdf.text('Historial de Velocidades', 215, 120);
					pdf.text('Inicio: ' + FECHA_INICIAL + ' - Fin: ' + FECHA_FINAL, 90, 145)

					const PROPERTIES = (pdf as any).getImageProperties(graficaImagen);
					const WIDTH = pdf.internal.pageSize.getWidth() - 2 * 15;
					const HEIGHT = (PROPERTIES.height * WIDTH) / PROPERTIES.width;
					pdf.addImage(graficaImagen, 'PNG', 15, 170, WIDTH, 250);

					pdf.setFontSize(14);
					pdf.setFont('', 'bold')
					pdf.text('Datos del Dispositivo', 90, 470,);

					pdf.setFont('', 'normal')
					pdf.text('Vehículo:', 90, 485);
					pdf.text(MARCA + ', ' + MODELO, 340, 485);

					pdf.text('Placa:', 90, 500);
					pdf.text(PLACA, 340, 500);

					pdf.text('Económico:', 90, 515);
					pdf.text(ECONOMICO, 340, 515);

					pdf.text('Número de Serie:', 90, 530);
					pdf.text(SERIE, 340, 530);

					pdf.text('Año:', 90, 545);
					pdf.text(ANIO + '', 340, 545);

					pdf.text('Color:', 90, 560);
					pdf.text(COLOR, 340, 560);

					pdf.text('Descripción:', 90, 575);
					pdf.text(DESCRIPCION, 340, 575);

					pdf.text('Dirección:', 90, 590);
					pdf.text(direccion + '', 340, 590);

					pdf.setFontSize(12);
					pdf.setFont('', 'bold')
					pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
					pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
					pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, soporte.star@growtec.com.mx', 65, 825);

					const nombreArchivo = 'Historial_Velocidades';
					pdf.save(nombreArchivo + '.pdf');
					this.loadingVisible = false;

				}
			)
		}, 1)
	}

	validarInfo(valor) {
		let value = 'Sin Datos';

		if (valor) {
			value = valor
		}

		return value;
	}

	public tickFormatting(date: any) {
		const options = {
			hour: 'numeric',
			minute: 'numeric',
		};
		if (date.constructor.name === 'Date') {
			return date.toLocaleString('es-MX', options);
		}
		return date.toLocaleString('es-MX', options);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


}
